import type { ChipOption } from '@experience/core-chips-ui';
import { FILTER_ORDER, CHIP_VALUE_TO_FILTER_KEY } from '../../const/order.ts';

/**
 * Возвращает ключ фильтра только для строковых value, которые участвуют в сортировке.
 */
const getFilterKey = (value: ChipOption['value']) => {
  if (typeof value !== 'string') {
    return undefined;
  }

  return CHIP_VALUE_TO_FILTER_KEY[value];
};

/**
 * Сортирует чипсы фильтров в соответствии с заданным порядком
 * @param chips Массив чипсов для сортировки
 * @returns Отсортированный массив чипсов
 */
export function sortFilterChips<T extends ChipOption>(chips: T[]): T[] {
  return [...chips].sort((a, b) => {
    const filterKeyA = getFilterKey(a.value);
    const filterKeyB = getFilterKey(b.value);

    const orderA = filterKeyA ? FILTER_ORDER[filterKeyA] : Infinity;
    const orderB = filterKeyB ? FILTER_ORDER[filterKeyB] : Infinity;

    return orderA - orderB;
  });
}
